var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.shadesSliderContentBlockV1 = {
    attach: function (context) {
      var $template = $('.js-shades-slider--v1', context);

      $template.each(function () {
        var $self = $(this);
        var $product = $self;
        var $shades = $self.find('.js-shades-slider-carousel');
        var settings = {
          rtl: site.direction.isRTL,
          arrows: true,
          infinite: true,
          slidesToShow: 9,
          slidesToScroll: 1,
          autoplay: false,
          centerMode: true,
          focusOnSelect: true,
          draggable: false,
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                arrows: false,
                slidesToShow: 7
              }
            },
            {
              breakpoint: 1024,
              settings: {
                arrows: false,
                draggable: true,
                slidesToShow: 5
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                draggable: true,
                slidesToShow: 3
              }
            }
          ],
          onAfterChange: function (self, index) {
            var slide = self.$slides[index];

            if (slide) {
              $product.trigger('product.skuSelect', $(slide).data('sku-id'));
            }
          }
        };

        $shades.slick(settings);
      });
    }
  };
})(jQuery);
